import type { Language, TranslationDictionary } from "@/lib/translations";

// Error screens remain readable even when a locale chunk cannot be downloaded.
export const essentialTranslations: Record<Language, TranslationDictionary> = {
  "en": {
    "field.error.updating": "Loading the current page.",
    "field.error.updatingDescription": "You will be browsing again in a moment.",
    "field.error.title": "This page could not be opened.",
    "field.error.description": "Check your internet connection and try again.",
    "field.error.reload": "Reload page",
    "field.error.home": "Back to home"
  },
  "pl": {
    "field.error.updating": "Ładujemy aktualną stronę.",
    "field.error.updatingDescription": "Za chwilę wrócisz do przeglądania.",
    "field.error.title": "Nie udało się otworzyć strony.",
    "field.error.description": "Sprawdź połączenie z internetem i spróbuj ponownie.",
    "field.error.reload": "Odśwież stronę",
    "field.error.home": "Wróć na stronę główną"
  },
  "de": {
    "field.error.updating": "Die aktuelle Seite wird geladen.",
    "field.error.updatingDescription": "Du kannst gleich weiterstöbern.",
    "field.error.title": "Diese Seite konnte nicht geöffnet werden.",
    "field.error.description": "Prüfe deine Internetverbindung und versuche es erneut.",
    "field.error.reload": "Seite neu laden",
    "field.error.home": "Zur Startseite"
  }
};
